<div *ngIf="prompt" class="bg-info bg-gradient">
    <span>{{prompt.label}}). </span><span [innerHTML]="prompt.questionText" class="text-start"></span>
</div>


<form [formGroup]="doQuestionForm"  *ngIf="prompt && !loading && !loading_option_images">
    <span *ngIf="prompt['questionPresentation']=='RADIOGROUP'">

    (<i>Select the Correct Answer from options below</i>)
    <table class="table">
      <tbody>
        <tr *ngFor="let choice of prompt.choiceOptions; index as myCount">
        <td>
           <div class="answer-option-radio-div">
             <input
             type="radio"
             [id]="myCount"
             formControlName="answerChoice"
             [value]="extractChoiceValue(choice)"
             style="height:35px; width:35px; vertical-align: middle;"/>
             <span [innerHTML]="' '+choice.display"></span>
        </div>
        </td>
    </tr>
  </tbody>
     </table>
    </span>
    <div class="row"  *ngIf="prompt['questionPresentation']=='INPUT'">
        <div class="col-sm-4" ></div>
        <div class="col-sm-4" >
            <input   formControlName="answerInput" class="form-control"/>
        </div>
    </div>

